import {QueryClient, QueryCache} from '@tanstack/react-query'
import axios from 'axios'

const getStatus = (e: unknown): number | undefined =>
  axios.isAxiosError(e) ? e.response?.status : undefined

const getMessage = (e: unknown): string =>
  (axios.isAxiosError(e) && e.response?.data?.message) ||
  (e instanceof Error ? e.message : 'Something went wrong')

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (count, error): boolean => {
        const status = getStatus(error)
        // don't retry 4xx — the answer won't change
        if (status && status < 500 && status !== 408 && status !== 429)
          return false
        return count < 2
      },
    },
    mutations: {
      retry: false,
    },
  },

  // one place for error toasts instead of every hook
  queryCache: new QueryCache({
    onError: (error): Error | undefined => {
      if (getStatus(error) === 401) return // auth interceptor's job
      console.error(getMessage(error))
    },
  }),
})
